import type { ClusterUpdatePayload, ExplosionClassName } from '@/types/geolocation';

const VALID_CLASS_NAMES = new Set<string>(['pushka', 'geran', 'roked', 'shots', 'none']);

function isObject(v: unknown): v is Record<string, unknown> {
  return v !== null && typeof v === 'object' && !Array.isArray(v);
}

export function validateClusterUpdate(raw: unknown): ClusterUpdatePayload | null {
  if (!isObject(raw)) return null;

  if (typeof raw.id !== 'string') return null;
  if (typeof raw.latitude !== 'number' || !Number.isFinite(raw.latitude)) return null;
  if (typeof raw.longitude !== 'number' || !Number.isFinite(raw.longitude)) return null;
  if (typeof raw.gdop !== 'number' || !Number.isFinite(raw.gdop)) return null;
  if (typeof raw.confidence !== 'number') return null;
  if (typeof raw.converged !== 'boolean') return null;
  if (typeof raw.method !== 'string') return null;
  if (typeof raw.sensorCount !== 'number') return null;
  if (typeof raw.className !== 'string' || !VALID_CLASS_NAMES.has(raw.className)) return null;
  if (typeof raw.rmsResidual !== 'number') return null;

  return {
    id: raw.id,
    latitude: raw.latitude,
    longitude: raw.longitude,
    gdop: raw.gdop,
    confidence: raw.confidence,
    converged: raw.converged,
    method: raw.method,
    sensorCount: raw.sensorCount,
    className: raw.className as ExplosionClassName,
    rmsResidual: raw.rmsResidual,
    createdAt: raw.createdAt as number,
    sensorPositions: raw.sensorPositions as ClusterUpdatePayload['sensorPositions'],
  };
}
